export enum ArchivedTicketActionsEnum {
  RESET = "reset",
  DELETE = "delete",
}
